<template>
  <div class="afiliasi-card-wrapper">
    <div v-for="(data, idx) in dataTransaksi" :key="`wd${idx}`" class="m-d-12">
      <SOSlotCard :card-type="typeCard">
        <template v-slot:card_head>
          <div>
            <label class="m-d-0">{{ data.id }}</label>
          </div>
        </template>
        <template v-slot:card_body>
          <div class="d-grid-1">
            <label class="m-d-0 rekening">
              <img src="@/assets/icons/bank-account.svg" alt="" class="m-r-4" style="height: 13px; margin-top: -2px" />
              <span>
                {{ `${data.bank.nama} - ${data.renening_afiliasi.no_rekening} ` }}
              </span>
            </label>
            <label class="m-d-0 nama-rekening">
              <img
                src="@/assets/icons/account-outline.svg"
                alt=""
                class="m-r-4"
                style="height: 13px; margin-top: -2px"
              />
              <span>
                {{ data.renening_afiliasi.nama_pemilik }}
              </span>
            </label>
            <label class="m-d-0 waktu-withdraw">
              <span>
                {{ `Diminta ${$moment(data.created_at).format("DD MMM YYYY")}` }}
              </span>
            </label>
          </div>
        </template>
        <template v-slot:card_footer>
          <div class="d-grid-2 align-center">
            <label class="m-d-0 wd-amount">
              <span class="f-14 f-c-black f-semi">{{ data.amount | currency }}</span>
              <span class="response-status" :class="`status-${lastWithdrawStatus(data)}`">{{
                lastWithdrawStatus(data)
              }}</span>
            </label>
            <label class="j-self-end m-d-0 f-12 f-c-midgrey f-regular">
              {{ `${$moment(data.updated_at).format("DD MMM YYYY")}` }}
            </label>
            <label class="gc-2 m-d-0 f-12 f-c-midgrey">
              {{ data.keterangan }}
            </label>
          </div>
        </template>
      </SOSlotCard>
    </div>
  </div>
</template>

<script>
import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

export default {
  name: "SOCardTarikTunai",
  props: {
    cardType: {
      type: String,
      required: true,
    },
    dataTransaksi: {
      type: Array,
      required: true,
    },
    withdrawStatus: {
      type: Object,
      required: true,
    },
  },
  components: {
    SOSlotCard,
  },
  computed: {
    lastWithdrawStatus() {
      return (data) => {
        let wdStat = this.withdrawStatus.idle;
        switch (data.status) {
          case 0:
            wdStat = this.withdrawStatus.do;
            break;
          case 1:
            wdStat = this.withdrawStatus.success;
            break;
          case 2:
            wdStat = this.withdrawStatus.reject;
            break;
          default:
            wdStat = this.withdrawStatus.idle;
            break;
        }
        return wdStat;
      };
    },
    typeCard() {
      return this.cardType;
    },
  },
};
</script>

<style scoped src="../styleScope.css"></style>

<style scoped>
.card-footer div label:nth-child(2) {
  width: 22vw;
  text-align: right;
}

.wd-amount {
  width: 60vw;
}

.response-status {
  margin-left: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
}

.status-Gagal {
  color: #964040;
  background-color: #fff1f1;
}

.status-Selesai {
  color: #40964c;
  background-color: #e8fcee;
}
.status-Diproses {
  color: #c29500;
  background-color: #fff8e1;
}
</style>
